module.exports = __webpack_public_path__ + "media/ลี่ขอดมยาดมก่อน.ef80ff2d.mp3";